import React from 'react';
import Header from './Header';
import Footer from './Footer';


const Layout: React.FC<{ children?: React.ReactNode }> = ({ children }) => {

   return (
      <>
         <Header />
         <div className='w-full md:my-12'>
            {children}
         </div>
         <Footer />
      </>
   )
};

export default Layout;